import React, { Component } from 'react';
import styles from './css-modules/audio_video.module.css';
import Iframe from 'react-iframe'
import Fade from 'react-reveal/Fade';

class VideoFrame extends Component {
  constructor(props) {
    super(props);
    this.state = {transBolean: false}
  }

  componentDidMount() {
    let parent = this;
    setTimeout(function(){ parent.setState({transBolean: true})}, 400);
  }

  componentDidMount
  render () {
    return (
      <div className={styles.video_frame_container}>
        <Fade when={this.state.transBolean} delay={500}>
          <Iframe className={styles.video_iframe} url={this.props.link}></Iframe>
        </Fade>
      </div>
    )
  }
}

export default VideoFrame;
